import React from 'react';
import {IIndicatorWithoutArrowProps, IndicatorWithoutArrow} from '../indicator-without-arrow';
import {IProgressProps, Progress} from '../progress';
import {Grid, GridColumn} from '../grid';

export interface IProgressWithIndicatorProps {
    progress: IProgressProps,
    indicator: IIndicatorWithoutArrowProps
}

const ProgressWithIndicator = (props: IProgressWithIndicatorProps): JSX.Element => (
    <Grid noWrap={true}>
        <GridColumn width={['max-xs']} className={'progress_with_indicator__progress'} >
            {props.progress && <Progress {...props.progress}/>}
        </GridColumn>
        <GridColumn width={['mix-xs']} className={'progress_with_indicator__indicator'}>
            {props.indicator && <IndicatorWithoutArrow {...props.indicator}/>}
        </GridColumn>
    </Grid>
);

export default ProgressWithIndicator;
